import { render, staticRenderFns } from "./ReadonlyFoodGroup.vue?vue&type=template&id=90b14848"
import script from "./ReadonlyFoodGroup.vue?vue&type=script&lang=js"
export * from "./ReadonlyFoodGroup.vue?vue&type=script&lang=js"
import style0 from "./ReadonlyFoodGroup.vue?vue&type=style&index=0&id=90b14848&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports